<!-- 行情分析 -->
<template>
<div class="info-block">
  <router-link :to="{path: '/sghq/details',query: {id:info.id}}" class="info-block-a" target="_blank">
    <div class="div-1">{{info.title}}</div>
    <div class="div-2">{{info.description}}</div>
    <div class="div-3">{{info.create_time}}</div>
  </router-link>
</div>
</template>
<script>
export default {
  name: 'JghqInfo2',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:120px;
  padding:0px 5px 0px 5px;
  margin:0px 0px 20px 0px;
  //background-color:green;
  border-bottom:1px solid #ddd;
  background-size: auto 150px;
  background-repeat: no-repeat;
  background-position: 0px 0px;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block-a:hover > .div-1{
  color:var(--color6);
  //border:1px solid orange;
  //box-shadow:0px 0px 1px 1px orange;
}

.info-block-a:hover > .div-2{
  color:var(--color6);
}

.div-1{
  height:30px;
  padding:0px 5px 0px 5px;
  margin-top:1px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  line-height:30px;
  color:#000;
  //border-radius:8px 8px 0px 0px;
  //background:#eee;
}


.div-2{
  height:50px;
  padding:0px 5px 0px 5px;
  margin-bottom:10px;
  font-size:12px;
  text-align:left;
  line-height:20px;
  color:var(--color2);
}

.div-3{
  position:relative;
  height:30px;
  width:100%;
  padding:0px 0px 0px 20px;
  background:#fff;
  font-size:12px;
  line-height:30px;
  color:#888;
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 0px 6px;
}


.data-ico{
  background-image:url(./../../assets/clock.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: 5px 3px;
}

.location-ico{
  background-image:url(./../../assets/location.png);
  background-size: 17px 17px;
  background-repeat: no-repeat;
  background-position: 5px 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/module/JghqInfo2.vue